import type { RemoveBrokerAccountResponse } from "../services/brokerIntegrationApi";

export function summarizeRemoveAccountResult(r: RemoveBrokerAccountResponse): string {
  const bits: string[] = [];
  if (typeof r.deleted_trades === "number") bits.push(`${r.deleted_trades} trades`);
  if (typeof r.deleted_transfers === "number" && r.deleted_transfers > 0) {
    bits.push(`${r.deleted_transfers} transfers`);
  }
  if (typeof r.deleted_reports === "number" && r.deleted_reports > 0) {
    bits.push(`${r.deleted_reports} reports`);
  }
  if (typeof r.deleted_backtests === "number" && r.deleted_backtests > 0) {
    bits.push(`${r.deleted_backtests} backtests`);
  }
  if (r.active_trade_account_cleared) bits.push("active account reset");
  if (r.import_metadata_pruned) bits.push("removed from account list");
  return bits.length ? bits.join(" · ") : "Account data removed from Tessera.";
}
